import axios from 'axios';
import urls from '../config/urls';

axios.defaults.withCredentials = true;
axios.defaults.timeout = 10000;

export async function logIssue(location, data) {
  return await axios.post(`${urls.hubUIApiRoot}/member/issues/log`, { location, data });
}
